export const KtznEventSubscriptionAction = {
  startWebsocketConnection: "startWebsocketConnection",
  stopWebsocketConnection: "stopWebsocketConnection",
  subscribeToConversations: "subscribeToConversations",
  unsubscribeFromConversations: "unsubscribeFromConversations",
  subscribeToConversation: "subscribeToConversation",
  unsubscribeFromConversation: "unsubscribeFromConversation",
  subscribeToTenant: "subscribeToTenant",
  unsubscribeFromTenant: "unsubscribeFromTenant",
  subscribeToUser: "subscribeToUser",
  unsubscribeFromUser: "unsubscribeFromUser",
  unsubscribeFromAllEvents: "unsubscribeFromAllEvents",
};
